module.exports = __webpack_public_path__ + "static/media/imageForVideo.1337d310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/video/imageForVideo.jpg
// module id = 560
// module chunks = 0